/**
 * Danish input for a country-local time (user, 19/10/2026: "always select
 * Danish time, and the local time under it"). The window, the layout time
 * and the digest stay the country's rules — saved in its own time — but the
 * operator types them on the Danish clock: these turn a saved country time
 * into the Danish one the picker shows, and a picked Danish time back into
 * the country time to save, exact for the run date (the planner's own
 * conversion). Without a timezone nothing is converted.
 * For Media Devoted | Created By Ciro Autiero
 */
import { dkToLocal, localToDk, mod1440 } from '@trafficpulse/shared';

import { hhmmToMinutes, minutesToHHMM } from '../format';
import { todayIn } from './today-clock';

/** The Danish clock time of a saved country time, and whether its Danish date is the day before (−1) or after (+1). */
export function dkOfLocal(localHhmm: string, tz: string | null, runDate?: string | null): { hhmm: string; shift: number } | null {
  const local = hhmmToMinutes(localHhmm);
  if (local === null) return null;
  const { dkMin, dayShift } = localToDk(local, todayIn(tz, runDate));
  return { hhmm: minutesToHHMM(dkMin), shift: dayShift };
}

/** The country time to save for a picked Danish time; null when the input is not HH:MM. */
export function localOfDk(dkHhmm: string, tz: string | null, runDate?: string | null): string | null {
  const dk = hhmmToMinutes(dkHhmm);
  if (dk === null) return null;
  return minutesToHHMM(mod1440(dkToLocal(dk, todayIn(tz, runDate))));
}
